import styled from 'styled-components';

export const Button = styled.button`
  font-family: var(--font-family-primary);
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-bold);
  border-radius: var(--border-radius-large);
  padding: 10px 20px;
  cursor: pointer;
  transition: background-color var(--transition-fast);
  border: 2px solid;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: 40px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:focus-visible {
    outline: 3px solid var(--ui-focus);
    outline-offset: 2px;
  }
`;

export const PrimaryButton = styled(Button)`
  background-color: var(--brand-primary);
  color: var(--text-inverse);
  border-color: var(--brand-primary);

  &:hover:not(:disabled) {
    background-color: var(--brand-primary-hover);
    border-color: var(--brand-primary-hover);
  }

  &:active:not(:disabled) {
    background-color: var(--brand-primary-active);
    border-color: var(--brand-primary-active);
  }

  &:disabled {
    background-color: var(--ui-disabled);
    color: var(--text-muted);
    border-color: var(--ui-disabled);
  }
`;

export const SecondaryButton = styled(Button)`
  background-color: var(--ui-surface-alt);
  color: var(--brand-primary);
  border-color: var(--brand-primary);

  &:hover:not(:disabled) {
    background-color: var(--ui-surface-hover);
    color: var(--brand-primary-hover);
    border-color: var(--brand-primary-hover);
  }

  &:active:not(:disabled) {
    background-color: var(--ui-surface-hover-light);
    color: var(--brand-primary-active);
    border-color: var(--brand-primary-active);
  }

  &:disabled {
    background-color: var(--ui-disabled);
    color: var(--text-muted);
    border-color: var(--ui-disabled);
  }
`;

export const SuccessButton = styled(Button)`
  background-color: var(--state-success-button);
  color: var(--text-inverse);
  border: none;

  &:hover:not(:disabled) {
    background-color: var(--state-success-hover);
  }

  &:disabled {
    background-color: var(--ui-disabled-dark);
  }
`;

export const DangerButton = styled(Button)`
  background-color: var(--state-error-button);
  color: var(--text-inverse);
  border: none;

  &:hover:not(:disabled) {
    background-color: var(--state-error);
  }

  &:disabled {
    background-color: var(--ui-disabled-dark);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: var(--space-2);
  align-items: center;

  &.vertical {
    flex-direction: column;
    align-items: stretch;
  }

  &.stretch {
    width: 100%;
    
    > * {
      flex: 1;
    }
  }
`;

